<i18n lang="yaml" locale="en">
  attention: Attention
  confirm delete slide: The content of this slide will be deleted. Continue?
  copy of: Copy of {title}
  soft limit slides reached: The recommenden number of slides ({limit}) is exceeded...
</i18n>

<i18n lang="yaml" locale="de">
  attention: Achtung
  confirm delete slide: Der Inhalt dieser Seite wird gelöscht. Fortfahren?
  copy of: Kopie von {title}
  soft limit slides reached: Die empfohlene Anzahl an Seiten ({limit}) ist überschritten...
</i18n>

<template>
  <div
    @mouseover="mouseover = true"
    @mouseleave="mouseover = false"
  >
    <slot />
    <transition name="fade">
      <div
        class="editor edit-slide"
        v-if="mouseover"
      >
        <span
          v-if="!$localeMode"
          class="move-handle"
        >
          <move
            size="xs"
            color="main-darker"
            class="icon"
          />
        </span>
        <settings
          size="xs"
          color="main-darker"
          class="icon"
          @click="editSlide()"
        />
        <copy
          v-if="!$localeMode"
          size="xs"
          color="main-darker"
          class="icon"
          @click="cloneSlide()"
        />
        <delete
          v-if="!$localeMode"
          size="xs"
          color="danger"
          class="icon delete"
          @click="deleteSlide()"
        />
      </div>
    </transition>
  </div>
</template>

<script>
import Move from '@/components/icons/Move'
import Settings from '@/components/icons/Settings'
import Copy from '@/components/icons/Copy'
import Delete from '@/components/icons/Delete'
import { Confirm, Warning } from '@/plugins/snotify'
import softLimits from '@/projectSoftLimits'

export default {
  name: 'SlideEditor',
  components: {
    Move,
    Settings,
    Copy,
    Delete
  },
  data () {
    return {
      mouseover: false
    }
  },
  methods: {
    deleteSlide () {
      const dispatch = () => {
        this.$store.dispatch('remove')
      }
      if (this.$store.getters.numChildren > 0) {
        new Confirm(this.$t('attention'), this.$t('confirm delete slide'), dispatch).open()
      } else {
        dispatch()
      }
    },
    editSlide () {
      this.$router.replace({ query: { edit: this.$store.getters.path } })
    },
    cloneSlide () {
      this.$store.dispatch('clone', {
        props: {
          // props to override
          title: this.$t('copy of', { title: this.$store.getters.props.title })
        }
      }).then(() => {
        if (this.$store.getters.parent.getters.numChildren > softLimits.slides) {
          new Warning('soft limit slides reached', { limit: softLimits.slides }).open()
        }
      })
    }
  },
  computed: {
    $localeMode () {
      return this.$parent.$localeMode
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/uiColors';

.edit-slide {
  position: absolute;
  top: 1.6vmin;
  right: 1vmin;

  .icon {
    margin-left: 8px;

    &.delete {
      margin-left: 16px;
    }
  }
}
</style>
